import classNames from 'classnames'
import { memo, useEffect, useRef, useState } from 'react'

import SmoothDropdown from 'components/ui/Dropdown/SmoothDropdown'
import { Input } from 'components/ui/Input/Input'
import usePopup from 'hooks/usePopup'
import { Option, SuggestsOption } from './SuggestsOption'

import './suggests.style.css'

interface Props<T extends { name: string }> {
  placeholder?: string
  options: Option<T>[]
  onSearch: (input: string) => void
  onSelect: (value: Option<T>) => void
}

const Suggests = <T extends { name: string }>({ placeholder = 'Type...', ...props }: Props<T>) => {
  const ref = useRef(null)
  const { open, setOpen } = usePopup(ref)
  const [option, setOption] = useState<Option<T>>(null)

  useEffect(() => {
    setOpen(!option && props.options.length !== 0)
  }, [option, props.options])

  const handleChange = (input: string) => {
    setOption(null)

    if (input === '') {
      setOpen(false)
      props.onSelect(null)
    }

    props.onSearch(input)
  }

  const handleFocus = () => {
    setOpen(props.options.length > 0)
  }

  const menuItems = props.options?.map((opt: Option<T>, index: number) => {
    const handleClick = () => {
      setOption(opt)
      props.onSelect(opt)
      setOpen(false)
    }

    return (
      <span key={index}>
        <SuggestsOption name={opt.name} onClick={handleClick}></SuggestsOption>
      </span>
    )
  })

  const classnames = classNames('suggests-value is-highlighted', { 'is-active': open })

  return (
    <div ref={ref} className="suggests-wrapper">
      <div className={classnames}>
        <Input
          isError={!option}
          value={option?.name}
          onChange={handleChange}
          onFocus={handleFocus}
          placeHolder={placeholder}
        />
      </div>
      <div className="suggests-menu top" style={open ? {} : { boxShadow: 'none', zIndex: 1 }}>
        <SmoothDropdown open={open} maxHeight={600}>
          {menuItems}
        </SmoothDropdown>
      </div>
    </div>
  )
}

export default memo(Suggests)
